import deepmerge from 'deepmerge';

export interface IPost {
  id: string | number;
  title: string;
  content: string;
  thumbnail?: string;
  created_at: Date;
  updated_at: Date;
}

export default class Post implements IPost {
  id: string | number = 0;
  title: string = '';
  content: string = '';
  thumbnail?: string;
  created_at: Date = new Date();
  updated_at: Date = new Date();

  constructor(obj: Partial<IPost>) {
    Object.assign(this, obj);
  }

  update(obj: Partial<IPost>) {
    Object.assign(this, obj);
    return this;
  }

  copyWith(obj: Partial<IPost>) {
    return new Post(deepmerge(Object.assign({}, this), obj));
  }

  static createFromEntity(obj: any) {
    return new Post({
      id: obj.id,
      title: obj.title,
      content: obj.content,
      thumbnail: obj.thumbnail,
      created_at: new Date(obj.created_at),
      updated_at: new Date(obj.updated_at)
    });
  }

  toEntity() {
    return {
      id: this.id,
      title: this.title,
      content: this.content,
      thumbnail: this.thumbnail,
      created_at: this.created_at.toISOString(),
      updated_at: this.updated_at.toISOString()
    };
  }
}
